export type UpdateCardModalProps = {
    title: string,
    titleIcon:  React.FunctionComponent<React.SVGProps<SVGSVGElement> & {
        title?: string | undefined;
    }>,
    actionText: string,
    onClose: Function,
    modalType?: UpdateCardModalType
}

export enum UpdateCardModalType {
    AddPO,
    UpdateKR
}